// admin/src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// Context
import { AdminAuthProvider }   from './context/AdminAuthContext';
import { RecycleBinProvider }  from './context/RecycleBinContext';  // ★ ADD

// Components
import AdminProtected from './components/AdminProtected';
import AdminLayout    from './components/AdminLayout';

// Pages
import AdminLogin         from './pages/AdminLogin';
import AdminDashboard     from './pages/AdminDashboard';
import ManageBookings     from './pages/ManageBookings';
import ManageContacts     from './pages/ManageContacts';
import ManageUsers        from './pages/ManageUsers';
import HeroSectionManager from './pages/HeroSectionManager';
import ManageTripDetails  from './pages/ManageTripDetails';
import ManageEnjoyTravel  from './pages/ManageEnjoyTravel';
import ManageBlogTravel   from './pages/ManageBlogTravel';
import ManageReviews        from './pages/ManageReviews';           // ★ ADD
import RecycleBin           from './pages/RecycleBin';              // ★ ADD

// Styles
import './styles/adminVariables.css';
import './App.css';

function App() {
  return (
    <Router>
      <AdminAuthProvider>
        <RecycleBinProvider>                                         {/* ★ ADD */}
          <Routes>
            {/* Login Route */}
            <Route path="/login" element={<AdminLogin />} />

            {/* Protected Admin Routes */}
            <Route
              path="/"
              element={
                <AdminProtected>
                  <AdminLayout />
                </AdminProtected>
              }
            >
              <Route index                   element={<AdminDashboard />}    />
              <Route path="trip-details"     element={<ManageTripDetails />} />
              <Route path="bookings"         element={<ManageBookings />}    />
              <Route path="users"            element={<ManageUsers />}       />
              <Route path="hero"             element={<HeroSectionManager />}/>
              <Route path="enjoy-travel"     element={<ManageEnjoyTravel />} />
              <Route path="blog-travel"      element={<ManageBlogTravel />}  />
              <Route path="contact-messages" element={<ManageContacts />}    />
              <Route path="reviews"          element={<ManageReviews />}     />{/* ★ ADD */}
              <Route path="recycle-bin"      element={<RecycleBin />}        />{/* ★ ADD */}
            </Route>

            {/* Catch all */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </RecycleBinProvider>                                        {/* ★ ADD */}
      </AdminAuthProvider>
    </Router>
  );
}

export default App;
